import { useUser } from 'src/hooks/queries/users';
import { UserModel, UserUtils } from 'src/types/user.model';

export default function useCurrentUser(): { isLoading: boolean; user: UserModel; isFullPlanUser: boolean } {
    const { isLoading, data: user } = useUser();
    const isFullPlanUser: boolean = !UserUtils.isBudgetingUser(user);

    return { isLoading, isFullPlanUser, user };
}
